module.exports = __webpack_public_path__ + "static/img/banner1.29c4a38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner1.png
// module id = 1MxG
// module chunks = 5